import { useState } from "react";
import { DollarIcon } from "@icons";
import {
    InstitutionIcon,
    type InstitutionIconSize,
} from "@design-system/InstitutionIcon/InstitutionIcon";
import { OptionToggle, VariantGrid, VariantItem } from "./playgroundControls";
import {
    brokenLogoUrlSample,
    institutionIconSizePixels,
    institutionIconSizes,
    logoUrlSample,
} from "./InstitutionIconPlayground.lib";
import {
    InstitutionIconCatalogueMatrix,
    InstitutionIconStacks,
} from "./InstitutionIconPlaygroundMatrix";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./InstitutionIconPlayground.module.scss";

/** Design-system sandbox for `InstitutionIcon`: sources, fallbacks, the catalogue and stacks. */
export const InstitutionIconPlayground = () => {
    const [size, setSize] = useState<InstitutionIconSize>("xl");

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Size of the source states</h2>
                    <OptionToggle
                        options={institutionIconSizes}
                        value={size}
                        onChange={setSize}
                    />
                </section>
            }
        >
            <ShowcasePreview
                summary={`${size} · ${institutionIconSizePixels[size]}px`}
                alignment="start"
                output={JSON.stringify({ InstitutionIcon: { size } }, null, 2)}
            >
                <div className={styles.content}>
                    <VariantGrid title="Sources" columns="auto">
                        <VariantItem label="institution">
                            <InstitutionIcon institution="chase" size={size} />
                        </VariantItem>
                        <VariantItem label="src">
                            <InstitutionIcon src={logoUrlSample} size={size} />
                        </VariantItem>
                        <VariantItem label="src null">
                            <InstitutionIcon src={null} size={size} />
                        </VariantItem>
                        <VariantItem label="broken src">
                            <InstitutionIcon
                                src={brokenLogoUrlSample}
                                size={size}
                            />
                        </VariantItem>
                        <VariantItem label="custom fallback">
                            <InstitutionIcon
                                src={null}
                                size={size}
                                fallback={<DollarIcon />}
                            />
                        </VariantItem>
                    </VariantGrid>
                    <InstitutionIconStacks />
                    <InstitutionIconCatalogueMatrix />
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
